import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@styles/color.styles";
import { size, lineHeight } from "@styles/type.styles";
import spacing from "@styles/spacing.styles";

const content: CSSProperties = {
  display: "flex",
  flexFlow: "row nowrap",
  alignItems: "center",
  justifyContent: "start",
  width: "100%",
};

const avatar: CSSProperties = {
  marginRight: spacing.sm,
  height: 30,
  width: 30,
  color: greys.white,
  backgroundColor: colors.blueCool.standard,
};

const text: CSSProperties = {
  fontSize: size.md,
  lineHeight: lineHeight.std,
};

const name: CSSProperties = {
  color: greys.darkGreyBlue,
  margin: "2px 0",
};

const email: CSSProperties = {
  color: greys.slate,
  margin: "2px 0",
};

const suggestedText: CSSProperties = {
  fontSize: size.md,
  lineHeight: lineHeight.std,
  color: colors.green.darker,
  marginLeft: "auto",
};

export const styles = {
  content,
  avatar,
  text,
  name,
  email,
  suggestedText,
};
